import React from "react";
import { useLocation, Outlet, Navigate } from "react-router-dom";

import { hasPermission } from "./helpers/selectors";
import { hasValidToken } from "./helpers/tokenStorage";
import { PermissionsProvider } from "./contexts/PermissionsProvider";

const ProtectedRoutes = ({ currentUser, requiredRole }) => {
  const location = useLocation();

  //  is user authenticated / has user the required role
  if (!hasValidToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requiredRole && !hasPermission(currentUser, requiredRole)) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // Mount PermissionsProvider once at the outermost authenticated
  // boundary so every route below shares one live snapshot of
  // /api/me/permissions. Nested ProtectedRoutes wrappers reach the
  // context through this instance — they don't need to re-provide
  // (and doing so would spawn duplicate 60s pollers). SCK-547.
  return (
    <PermissionsProvider>
      <Outlet />
    </PermissionsProvider>
  );
};

export default ProtectedRoutes;
